import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column" }
const _hoisted_2 = { class: "p-float-label p-col-12 p-mt-2" }
const _hoisted_3 = {
  for: "selectedCube",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-scenario-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.descriptor.style.dialog,
    visible: _ctx.visible,
    modal: true,
    closable: false,
    draggable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.scenarioWizard.title')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "fas fa-info-circle",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showInfo = !_ctx.showInfo))
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button",
        onClick: _ctx.resetScenarioData
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.scenarioWizard.clearData')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.saveScenario,
        disabled: _ctx.saveButtonDisabled
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.showInfo)
          ? (_openBlock(), _createBlock(_component_InlineMessage, {
              key: 0,
              class: "p-m-2",
              severity: "info"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.scenarioWizard.longInfo')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Dropdown, {
            id: "selectedCube",
            class: "kn-material-input",
            modelValue: _ctx.selectedCube,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedCube = $event)),
            options: _ctx.cubes,
            optionLabel: "name",
            onChange: _ctx.onCubeChange
          }, null, 8, ["modelValue", "options", "onChange"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('documentExecution.olap.scenarioWizard.selectedCube')), 1)
        ]),
        _createVNode(_component_Card, { class: "p-m-2" }, {
          header: _withCtx(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.scenarioWizard.editableMeasures')), 1)
              ]),
              _: 1
            })
          ]),
          content: _withCtx(() => [
            _createVNode(_component_DataTable, {
              value: _ctx.measures,
              selection: _ctx.scenario.MEASURE,
              "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.scenario.MEASURE = $event)),
              class: "p-datatable-sm kn-table",
              dataKey: "XML_TAG_TEXT_CONTENT",
              responsiveLayout: "stack",
              breakpoint: "960px",
              scrollable: true,
              scrollHeight: "flex"
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  class: "kn-column-checkbox",
                  selectionMode: "multiple",
                  dataKey: "XML_TAG_TEXT_CONTENT"
                }),
                _createVNode(_component_Column, {
                  field: "XML_TAG_TEXT_CONTENT",
                  header: _ctx.$t('common.name')
                }, null, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value", "selection"])
          ]),
          _: 1
        }),
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mx-2" }, {
          start: _withCtx(() => [
            (!_ctx.expandParamsCard)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "fas fa-chevron-right",
                  class: "p-button-text p-button-rounded p-button-plain",
                  style: {"color":"white"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expandParamsCard = true))
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  icon: "fas fa-chevron-down",
                  class: "p-button-text p-button-rounded p-button-plain",
                  style: {"color":"white"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.expandParamsCard = false))
                })),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.datasetManagement.params')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "fas fa-plus",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.addNewParam
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              icon: "fas fa-eraser",
              class: "p-button-text p-button-rounded p-button-plain",
              disabled: _ctx.disableDeleteAll,
              onClick: _ctx.removeAllParams
            }, null, 8, ["disabled", "onClick"])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_Card, { class: "p-mx-2 p-mb-2" }, {
          content: _withCtx(() => [
            _createVNode(_component_DataTable, {
              class: "p-datatable-sm kn-table",
              editMode: "cell",
              value: _ctx.scenario.VARIABLE,
              scrollable: true,
              scrollHeight: "250px",
              responsiveLayout: "stack",
              breakpoint: "960px"
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.tableEmpty')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "name",
                  header: _ctx.$t('documentExecution.olap.scenarioWizard.parameterName')
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: data.name,
                      "onUpdate:modelValue": ($event: any) => (data.name = $event),
                      style: _ctx.descriptor.style.columnStyle
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "style"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "value",
                  header: _ctx.$t('documentExecution.olap.scenarioWizard.parameterValue')
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: data.value,
                      "onUpdate:modelValue": ($event: any) => (data.value = $event),
                      style: _ctx.descriptor.style.columnStyle
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "style"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  onRowClick: false,
                  style: _ctx.descriptor.style.iconColumn
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Button, {
                      icon: "pi pi-trash",
                      class: "p-button-link",
                      onClick: ($event: any) => (_ctx.removeParam(slotProps))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.expandParamsCard]
        ])
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}